<div class="header-wrapper">
    <mat-icon class="languageIcon" (click)="openModal()">language</mat-icon>

    <ul class="navbar-user-list">
        <li>
            <app-user-navigation></app-user-navigation>
        </li>
    </ul>
</div>
